module.exports = __webpack_public_path__ + "static/media/met-logo-hvit-eng.0496cb78.svg";